import { FC, ReactNode, useRef } from 'react';

import { DropdownArrowIcon } from '@/components/ui/Icons/Icons';
import { Typography } from '@/components/ui/Typography/Typography.styles';

import * as S from './Panel.styles';

type Props = {
  children: ReactNode;
  header: string;
  value: string | number;
  isOpen: boolean;
  onChange: (value: Props['value']) => void;
};

export const Panel: FC<Props> = ({
  children,
  header,
  value,
  onChange,
  isOpen
}: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const height = useRef<number>(0);

  const handleClick = () => {
    const contentHeight = ref.current?.nextElementSibling?.scrollHeight;
    height.current = contentHeight ?? 0;
    onChange(value);
  };

  return (
    <S.Wrapper>
      <S.Header ref={ref} onClick={handleClick} $isOpen={isOpen}>
        <Typography variant="title4">{header}</Typography>
        <DropdownArrowIcon />
      </S.Header>
      <S.ContentWrapper $isOpen={isOpen} $height={height.current}>
        {children}
      </S.ContentWrapper>
    </S.Wrapper>
  );
};
